import { Toolbar as MuiToolbar, ToolbarProps } from '@mui/material';

const Toolbar = ({ children, ...rest }: ToolbarProps) => (
	<MuiToolbar {...rest}>{children}</MuiToolbar>
);

export default Toolbar;
